module.exports = __webpack_public_path__ + "img/l.af808978.jpg";